const actions = {
	makeToast(context, options) {
		this._vm.$swal({
			toast: true,
			position: 'top-end',
			icon: options.icon || 'success',
			title: options.title || 'titulo',
			showConfirmButton: false,
			timer: options.timer || 3000
		});
	},
	async makeAlert(context, options) {
		const alert = await new Promise((resolve) => {
			const swal = this._vm.$swal({
				icon: options.icon || 'success',
				customClass: {
					confirmButton: options.btnClasses || 'ml-3 main-btn',
					cancelButton: options.btnCancelClasses || 'ml-3 main-btn btn-cancel'
				},
				showCancelButton: options.showCancelBtn || false,
				cancelButtonText: options.btnCancelText || 'Cancelar',
				confirmButtonText: options.btnText || 'Aceptar',
				buttonsStyling: false,
				title: options.title || 'Titulo',
				text: options.text || 'texto',
				reverseButtons: true
			});
			resolve(swal);
		});
		return alert;
	}
};

export default {
	actions,
	namespaced: true
};
